module.exports = __webpack_public_path__ + "static/img/15.d16ee40.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/eng/15.png
// module id = 98LX
// module chunks = 0